
import React, { useState, useEffect } from "react";
import { Button, Card, Col, Collapse, Form, Input, message, Row, Spin, Select, Upload, InputNumber } from "antd";
import { useAuthContext } from "../../context/AuthContext";
import { API } from "../../constant";
import { getToken } from "../../helpers";
import { useParams, useNavigate } from "react-router-dom";
import { CameraOutlined, ImportOutlined } from "@ant-design/icons";
import imageCompression from 'browser-image-compression'; // Importa la biblioteca

const { Option } = Select;
const { Dragger } = Upload;
const { Panel } = Collapse;

const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(() =>
    typeof window !== 'undefined' && window.matchMedia('(max-width: 768px)').matches
  );
  useEffect(() => {
    const mq = window.matchMedia('(max-width: 768px)');
    const handler = (e) => setIsMobile(e.matches);
    mq.addEventListener('change', handler);
    return () => mq.removeEventListener('change', handler);
  }, []);
  return isMobile;
};

const NewVisit = () => {
  const [loading, setLoading] = useState(false);
  const isMobile = useIsMobile();
  const [activeMarca, setActiveMarca] = useState(['0']);
  const { user } = useAuthContext();
  const params = useParams();
  const { clienteId } = params;
  const [clienteData, setClienteData] = useState(null);
  const [marcas, setMarcas] = useState([]);
  const [imagenes, setImagenes] = useState([]); // Estado para las imágenes
  const [textAreaValue, setTextAreaValue] = useState([]);
  const [implantacionTypes, setImplantacionTypes] = useState([]);
  const [form] = Form.useForm();
  const marcasSelect = [
    "ARGON18", "AVID", "BELL","BLACKBURN","BLUM","CAMELBAK","C-PREME","CRANKBROTHERS","ENDURO BEARINGS","EVOC",
    "FIDLOCK", "FIZIK", "FIZIK COMPONENTES", "FIZIK SILLINES", "FIZIK ZAPATILLAS",
    "FINISH LINE", "GENUINE INNOVATIONS", "GIRO CALCETINES", "GIRO CASCOS",
    "GIRO GUANTES", "GIRO NEW ROAD", "GIRO ZAPATILLAS", "HAWKERS","HYDRAPACK",
    "LEZYNE", "LIZARD SKINS","MAXXIS","OFERTAS", "ONOFF", "PARK TOOL","PELOTAN",
    "QUARQ", "ROCKSHOX", "SANTA MADRE", "SELLE ROYAL", "SENSUS", "SLIME","SOARING",
    "SRAM", "TIME", "TOWCAR", "TROY LEE DESIGNS", "TUBOLIGHT", "UTO", "X-SAUCE",
    "ZIPP", "OTROS"
  ];

  useEffect(() => {
    const fetchClienteData = async () => {
      try {
        const response = await fetch(`${API}/clientes/${clienteId}`, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${getToken()}`,
          },
        });
        const clienteData = await response.json();
        setClienteData(clienteData);
        console.log(clienteData)
      } catch (error) {
        console.error(error);
        message.error("Error while fetching client data!");
      }
    };
    fetchClienteData();
  }, [clienteId]);

  useEffect(() => {
    const fetchImplantacionTypes = async () => {
      try {
        const response = await fetch(`${API}/implantaciontypes`, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${getToken()}`,
          },
        });
        const data = await response.json();

        const filteredData = data.data
          .filter(item => item.attributes.Name && item.attributes.Name.startsWith("IMP "))
          .filter(item => item.attributes.U_TB_VENTA === "SI")
          .sort((a, b) => a.attributes.Name.localeCompare(b.attributes.Name));
        setImplantacionTypes(filteredData);
      } catch (error) {
        console.error(error);
        message.error("Error while fetching implantation types!");
      }
    };
    fetchImplantacionTypes();
  }, []);

  const handleCopyClick = (index) => {
    if (textAreaValue[index] !== undefined) {
      navigator.clipboard.writeText(textAreaValue[index]);
    }
  };

  const navigate = useNavigate();
  const handleClientesClick = () => {
    navigate(`/clients`);
  };

  useEffect(() => {
    if (!getToken()) {
      navigate('/signin');
    }
  }, [navigate]);

  // Función para comprimir imágenes
  const compressImage = async (file) => {
    const options = {
      maxSizeMB: 0.5, // Máximo 500KB
      maxWidthOrHeight: 1000, // Máximo 1000px de ancho o alto
      useWebWorker: true,
    };
    try {
      const compressedFile = await imageCompression(file, options);
      return compressedFile;
    } catch (error) {
      console.error("Error al comprimir la imagen:", error);
      return file; // Si falla la compresión, devuelve el archivo original
    }
  };

  // Subir imágenes al servidor
  const uploadImages = async () => {
    const formData = new FormData();
    imagenes.forEach(img => {
      formData.append('files', img.originFileObj); // Subir solo los objetos de archivo reales
    });

    const response = await fetch(`${API}/upload`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
      body: formData,
    });

    if (!response.ok) {
      throw new Error("Error al subir imágenes");
    }

    return await response.json();
  };

  const handleProfileUpdate = async (data) => {
    setLoading(true);

    try {
      if (user && user.id) {
        data.agente = user.id;
        data.cliente = { id: clienteId };
        data.tiene_web = data.tiene_web === true || data.tiene_web === "true" ? true : false;
        console.log(data.cliente)
        // Subir imágenes si hay alguna
        let uploadedImages = [];
        if (imagenes.length > 0) {
          uploadedImages = await uploadImages();
          data.imagenes = uploadedImages.map(img => img.id);
        }

        const response = await fetch(`${API}/visitas`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${getToken()}`,
          },
          body: JSON.stringify({ data }),
        });

        if (!response.ok) {
          throw new Error("Failed to submit form");
        }

        message.success("Visita guardada correctamente");
      } else {
        message.error("Ha ocurrido un error");
      }
    } catch (error) {
      console.error(error);
      message.error("Ha ocurrido un error al guardar la visita");
    } finally {
      setLoading(false);
      handleClientesClick();
    }
  };

  if (!clienteData) {
    return <Spin size="large" />;
  }

  return (
    <Card className="profile_page_card">
      <Form
        form={form}
        layout="vertical"
        initialValues={{
          cliente: clienteData.data.attributes.nombre,  // Usar el nombre correcto del cliente
          lugar: "Tienda",
          tipo: "Presentación",
          tiene_web: "No"
        }}
        onFinish={handleProfileUpdate}
      >
        <Row gutter={[16, 16]}>
          <Col md={12} lg={12} sm={24} xs={24}>
            <Form.Item
              label="Cliente"
              name="cliente"
              rules={[{ required: true, message: "Falta el campo cliente" }]}
            >
              <Input placeholder="Cliente" disabled value={clienteData.data.attributes.nombre} />
            </Form.Item>
          </Col>
          <Col md={4} lg={4} sm={24} xs={24}>
            <Form.Item label="Lugar" name="lugar">
              <Select>
                <Option value="Tienda">Tienda</Option>
                <Option value="Showroom">Showroom</Option>
                <Option value="Trabajo de oficina">Trabajo de oficina</Option>
                <Option value="Otro">Otro</Option>
              </Select>
            </Form.Item>
          </Col>
          <Col md={4} lg={4} sm={24} xs={24}>
            <Form.Item label="Tipo de visita" name="tipo">
              <Select>
                <Option value="Presentación">Presentación</Option>
                <Option value="Reposición">Reposición</Option>
                <Option value="Cortesía">Cortesía</Option>
                <Option value="Apertura">Apertura</Option>
                <Option value="Evento">Evento</Option>
                <Option value="Formación">Formación</Option>
                <Option value="Otros">Otros</Option>
                <Option value="Estudio de mercado">Estudio de mercado</Option>
              </Select>
            </Form.Item>
          </Col>
        </Row>

        {marcas.length > 0 && (
          <Collapse
            accordion
            activeKey={activeMarca}
            onChange={(key) => setActiveMarca(key)}
            style={{ marginBottom: 16, backgroundColor: 'aliceblue' }}
          >
            {marcas.map((marca, index) => {
              const selectedMarca = form.getFieldValue(`marca${index}`);
              const header = (
                <span>
                  Marca {index + 1}
                  {selectedMarca ? ` — ${selectedMarca}` : ''}
                </span>
              );
              return (
                <Panel header={header} key={String(index)} forceRender>
                  <Row gutter={[16, 16]}>
                    <Col xs={24} sm={24} md={6} lg={6}>
                      <Form.Item label="Marca" name={`marca${index}`}>
                        <Select
                          showSearch
                          placeholder="Selecciona una marca"
                          onChange={() => setActiveMarca([String(index)])}
                        >
                          {marcasSelect.map((marcaSelect, i) => (
                            <Option key={`${i}`} value={`${marcaSelect}`}>{marcaSelect}</Option>
                          ))}
                        </Select>
                      </Form.Item>
                      <Form.Item label="Forma de Pago" name={`formaPago${index}`}>
                        <Select placeholder="Forma de pago">
                          <Option value="Contado">Contado</Option>
                          <Option value="a 8 días">a 8 días</Option>
                          <Option value="a 30 días">a 30 días</Option>
                          <Option value="a 60 días">a 60 días</Option>
                          <Option value="a 90 días">a 90 días</Option>
                          <Option value="a 30/60 días">a 30/60 días</Option>
                          <Option value="a 30/60/90 días">a 30/60/90 días</Option>
                          <Option value="Otros">Otros</Option>
                        </Select>
                      </Form.Item>
                      <Form.Item label="Implantación" name={`implantacionMarca${index}`} style={{ width: '100%' }}>
                        <Select showSearch placeholder="Tipo de implantación" optionFilterProp="children">
                          {implantacionTypes.map((implantacionType) => (
                            <Option key={implantacionType.attributes.Code} value={implantacionType.attributes.Code}>
                              {implantacionType.attributes.Name}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={4} lg={4}>
                      <Form.Item label="Pedido" name={`pedido${index}`}>
                        <Select placeholder="Estado del pedido">
                          <Option value="No">No</Option>
                          <Option value="Pendiente">Pendiente</Option>
                          <Option value="SAP">SAP</Option>
                          <Option value="Excel">Excel</Option>
                          <Option value="B2B">B2B</Option>
                        </Select>
                      </Form.Item>
                      <Form.Item label="Descuento %" name={`descuento${index}`}>
                        <InputNumber min={0} max={70} inputMode="decimal" style={{ width: '100%' }} />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={12} lg={12}>
                      <Form.Item
                        label={<span>Comentarios de Marca <ImportOutlined style={{ margin: '10px' }} onClick={() => handleCopyClick(index)} size="small" /></span>}
                        name={`reporteMarca${index}`}
                        rules={[{ required: false, type: "string", max: 1620 }]}
                      >
                        <Input.TextArea
                          placeholder="Comentarios sobre esta marca"
                          value={textAreaValue[index] || ""}
                          autoSize={{ minRows: 3, maxRows: 8 }}
                          onChange={e => {
                            let updatedValues = [...textAreaValue];
                            updatedValues[index] = e.target.value;
                            setTextAreaValue(updatedValues);
                          }}
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                </Panel>
              );
            })}
          </Collapse>
        )}

        <Row gutter={[16, 16]}>
          <Col md={24} lg={24} sm={24} xs={24}>
            <div style={{ display: 'flex', justifyContent: 'left', marginBottom: 30, marginTop: 10 }}>
              <Button
                style={{ marginLeft: 0, marginRight: 10 }}
                className="profile_save_btn"
                htmlType="button"
                type="primary"
                size="small"
                onClick={() => {
                  const newIndex = marcas.length;
                  setMarcas([...marcas, newIndex + 1]);
                  setActiveMarca([String(newIndex)]);
                }}
              >
                +
              </Button> Añadir marca
            </div>
          </Col>
        </Row>

        {/* Campos adicionales: Tiene Web, Plataforma, Notas Personales 
        <Row gutter={[16, 16]}>
          <Col md={4} lg={4} sm={24} xs={24}>
            <Form.Item label="Tiene web" name="tiene_web">
              <Select>
                <Option value={false}>No</Option>
                <Option value={true}>Sí</Option>
              </Select>
            </Form.Item>
          </Col>
          <Col md={4} lg={4} sm={24} xs={24}>
            <Form.Item label="Plataforma" name="plataforma">
              <Select>
                <Option value="Prestashop">Prestashop</Option>
                <Option value="Wordpress">Wordpress</Option>
                <Option value="Shopify">Shopify</Option>
                <Option value="Magento">Magento</Option>
                <Option value="Otra">Otra</Option>
              </Select>
            </Form.Item>
          </Col>
        </Row>
*/}
        {/* Comentarios generales de la visita */}
        <Row gutter={[16, 16]}>
          <Col md={24} lg={24} sm={24} xs={24}>
            <Form.Item label="Comentarios generales de la visita" name="report" rules={[{ required: false, type: "string", max: 2620 }]}>
              <Input.TextArea placeholder="" autoSize={{ minRows: 4, maxRows: 10 }} />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[16, 16]}>
          <Col md={24} lg={24} sm={24} xs={24}>
            <Form.Item label="Notas Personales" name="reportPersonal">
              <Input.TextArea style={{ backgroundColor: 'antiquewhite' }} autoSize={{ minRows: 3, maxRows: 8 }} />
            </Form.Item>
          </Col>
        </Row>

        {/* Sección de fotos */}
        <Row gutter={[16, 16]}>
          <Col span={24}>
            <Form.Item label="Añadir Fotos">
              {(() => {
                const uploadProps = {
                  name: "imagenes",
                  multiple: true,
                  fileList: imagenes,
                  accept: "image/*",
                  beforeUpload: async (file) => {
                    const compressedFile = await compressImage(file);
                    const newFile = {
                      uid: compressedFile.uid,
                      name: compressedFile.name,
                      status: 'done',
                      originFileObj: compressedFile,
                    };
                    setImagenes(prevImages => [...prevImages, newFile]);
                    return false;
                  },
                  onRemove: (file) => {
                    setImagenes(prevImages => prevImages.filter(img => img.uid !== file.uid));
                  },
                };
                return isMobile ? (
                  <Upload {...uploadProps} listType="picture">
                    <Button icon={<CameraOutlined />} block size="large">
                      Tomar foto / añadir archivo
                    </Button>
                  </Upload>
                ) : (
                  <Dragger {...uploadProps}>
                    <p className="ant-upload-drag-icon">
                      <CameraOutlined />
                    </p>
                    <p className="ant-upload-text">Haz clic o arrastra el archivo para subir</p>
                    <p className="ant-upload-hint">Soporte para subida de múltiples archivos</p>
                  </Dragger>
                );
              })()}
            </Form.Item>
          </Col>
        </Row>

        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            position: 'sticky',
            bottom: 0,
            background: '#fff',
            padding: '12px 0',
            borderTop: '1px solid #f0f0f0',
            marginTop: 16,
            zIndex: 10,
            gap: 12,
          }}
        >
          <Button style={{ marginLeft: 0, flex: isMobile ? 1 : 'initial' }} className="profile_save_btn" htmlType="button" type="primary" size="large" onClick={handleClientesClick} ghost>
            Volver
          </Button>
          <Button style={{ flex: isMobile ? 2 : 'initial' }} className="profile_save_btn" htmlType="submit" type="primary" size="large" loading={loading}>
            {loading ? "Guardando..." : "Guardar visita"}
          </Button>
        </div>
      </Form>
    </Card>
  );
};

export default NewVisit;
